import {
  Position,
  OverlayToasterProps,
  OverlayToaster,
} from '@blueprintjs/core';
import { createRoot } from 'react-dom/client';

export default function createToaster(
  props?: OverlayToasterProps,
  container = document.body
) {
  const containerElement = document.createElement('div');
  container.appendChild(containerElement);
  const root = createRoot(containerElement);
  return new Promise<OverlayToaster>((resolve, reject) => {
    root.render(
      <OverlayToaster
        {...props}
        usePortal={false}
        ref={(instance) => {
          if (!instance) {
            reject(new Error('[Blueprint] Unable to create toaster.'));
          } else {
            resolve(instance);
          }
        }}
      />
    );
  });
}
/** Singleton toaster instance. Create separate instances for different options. */
export const AppToaster = createToaster({
  position: Position.BOTTOM,
});
